const initialState = {
  data: null,
};

const preparationDeliveryReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_PREP_DEL":
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};

export default preparationDeliveryReducer;
